import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../state/store";

export interface UserState {
  authKey: string | null;
  email: string | null;
  isStaff: boolean;
}

const initialState: UserState = {
  authKey: null,
  email: null,
  isStaff: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    login: (state, action: PayloadAction<{ email: string; key: string; isStaff: boolean }>) => {
      state.email = action.payload.email;
      state.authKey = action.payload.key;
      state.isStaff = action.payload.isStaff;
    },
    logout: (state) => {
      state.email = null;
      state.authKey = null;
      state.isStaff = false;
    },
  },
});

export const { login, logout } = userSlice.actions;

export const selectIsAuthenticated = (state: RootState) => state.user.authKey !== null;
export const selectIsStaff = (state: RootState) => state.user.isStaff;

export const userReducer = userSlice.reducer;
